import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import { gotoLogin, navigateTo } from "~/utils";
import UI from "~/ui";
import $ from "jquery";

class VenditeSeguite extends Page {

    private auth: any = null;
    private userInfo: any = null;
    private UserId: number = 0;

    constructor() {
        super("venditeseguite", "Vendite Seguite");
    }

    pageStart(): Promise<void> {
        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo");

        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId;

        // Inizializza gli event handler
        this.initEventHandlers();

        return Promise.resolve();
    }

    /**
     * Inizializza tutti gli event handler della pagina
     */
    private initEventHandlers(): void {
        this.initDeleteButtons();
    }

    /**
     * Inizializza i pulsanti di eliminazione delle vendite seguite, 
     * associando un event handler per la conferma e l'eliminazione della vendita seguita
     */
    private initDeleteButtons(): void {
        $(".elimina").on("click", (e) => {
            e.preventDefault();
            const element = e.currentTarget as HTMLElement;
            const lottoId = $(element).data("id") as number;

            if (!lottoId || isNaN(lottoId)) {
                console.error("ID lotto non valido:", lottoId);
                UI.confirmOneButton("", "Errore: ID lotto non valido");
                return;
            }

            UI.confirm(
                "Conferma eliminazione",
                "Sei sicuro di voler eliminare questa vendita seguita?",
                "",
                async (result: boolean) => {
                    if (result) {
                        await this.removeVenditaSeguita(lottoId);
                    }
                }
            );
        });
    }

    /**
    * Rimuove una vendita seguita
    * @param lottoId - ID del lotto della vendita da eliminare
    */
    private async removeVenditaSeguita(lottoId: number): Promise<void> {
        const spinner = this.spinner.spin();

        try {
            const url = `${window.BaseUrlWebApi}/VenditaSeguita/DeleteByLottoIdAndAnagraficaId?lottoId=${lottoId}&&anagraficaId=${this.UserId}`;

            await this.auth.fetchWithAuth(`DELETE ${url}`, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            // Rimuove l'elemento dal DOM con animazione
            $(`#box${lottoId}`).fadeOut(300, () => {
                $(`#box${lottoId}`).remove();

                // Controlla se esistono altre vendite seguite rimanenti dopo la rimozione
                this.checkRemainingVendite();
            });


        } catch (error) {
            console.error("Errore durante la cancellazione della vendita seguita:", error);
            UI.confirmOneButton("", "Errore durante la cancellazione della vendita seguita");
        } finally {
            this.spinner.stop();
        }
    }

    /**
     * Controlla se esistono vendite seguite rimanenti
     * Se non ci sono più vendite seguite, reindirizza alla pagina "nessuna vendita seguita"
     */
    private checkRemainingVendite(): void {
        // Conta le vendite seguite rimanenti (box visibili)
        const remainingVendite = $('[id^="box"]').filter(':visible').length;

        if (remainingVendite === 0) {
            console.log("Nessuna vendita seguita rimanente, reindirizzamento...");

            // Reindirizza alla pagina "nessuna vendita seguita"
            setTimeout(() => {
                navigateTo("/nessuna-vendita-seguita");
            }, 500); // Piccolo delay per permettere all'utente di vedere il messaggio
        }
    }

}

export default VenditeSeguite;